import { RoleTitle } from '../roles'

export default {
  edit: { lazy: () => import('../roles/Roles'), component: 'RoleEdit' },
  options: {
    edit: {
      title: <RoleTitle />,
      subtitle: 'Manage details and permissions for your team member.',
      breadCrumb: 'Edit Team Member',
    },
  },
}
